import { unloadPeople } from './importantpeople/action'
import { unloadDebt } from './debts/action'
import { unloadIncomes } from './income/action'
import { unloadExpense } from './lifestyle/action'
import { unloadProperty } from './properties/action'
import { unloadSavings } from './savings/action'

export const unloadThisYearData = () => dispatch => {
  dispatch(unloadPeople())
  dispatch(unloadDebt())
  dispatch(unloadIncomes())
  dispatch(unloadExpense())
  dispatch(unloadProperty())
  dispatch(unloadSavings())
}
